import { MotionControlBanner } from 'shared-ui/assets'
import {ROUTES} from 'shared-ui/utils/constants'

/** AI Tool Identifiers */
export const AI_TOOL_IDS = {
  FACE_SWAP: '13bc568d-bd0f-4d2a-bd97-fe88c6d47689',
  COLORIZE: '7c60ba5d-7a4d-4fc5-a70b-a9fa91a39b30',
  SCENE_SWAP: '93ee5d74-b3c6-4cdf-96ab-e1decb7a39f7',
  TEXT_TO_IMAGE: 'b0b14e70-e1c2-47b1-80ef-8f707dcfb045',
  TEXT_TO_VIDEO: '8d018a2a-667d-48d1-8f6b-566d51139945',
  VOICE_CLONE: '53e8d822-56c5-468a-adce-f1c8b1e6164f',
  VOICE_REMIX: 'cba6ff0c-30e5-4568-b266-2c035eceb23b',
  IMAGE_TO_VIDEO: '8329afcf-233f-479f-9a16-d58a0b0be627',
  ACTION_GENERATION: '65ed7090-9979-41c0-bf5f-73223398dd53',
  TALKING_AVATAR: '7e9c704c-abea-4b6f-8d1d-96edfbc5787f',
  MOTION_CONTROL: '7e9c704c-abea-4b6f-8d1d-96edfbc578a3',
  SONG_GENERATION: '2b563806-6ad2-4794-a4fe-fb95bbb17ad2',
  VIDEO_DUBBING: 'd1b2c3e4-f5a6-7b8c-9d0e-1f2a3b4c5d6e'
}

export const RENAMED_AI_TOOLS = {
  [AI_TOOL_IDS.FACE_SWAP]: 'Make Me a Star',
  [AI_TOOL_IDS.COLORIZE]: 'Bring Old Photos to Life',
  [AI_TOOL_IDS.SCENE_SWAP]: 'Step Into the Scene',
  [AI_TOOL_IDS.TEXT_TO_IMAGE]: 'Imagine It',
  [AI_TOOL_IDS.IMAGE_TO_VIDEO]: 'Animate My Scene',
  [AI_TOOL_IDS.TEXT_TO_VIDEO]: 'Ban Jao Director',
  [AI_TOOL_IDS.VOICE_CLONE]: 'Create My Voice',
  [AI_TOOL_IDS.VOICE_REMIX]: 'Sing Like a Star',
  [AI_TOOL_IDS.ACTION_GENERATION]: 'Animate Me',
  [AI_TOOL_IDS.MOTION_CONTROL]: 'Make Me a Dancer',
  [AI_TOOL_IDS.TALKING_AVATAR]: 'Bring My Character to Life',
  [AI_TOOL_IDS.SONG_GENERATION]: 'Make Me a Singer',
  [AI_TOOL_IDS.VIDEO_DUBBING]: 'Dub My Video'
}

export const CREATED_WITH_OPTIONS = [
  { label: 'Face Swap', value: 'face_swap', is_default: false },
  { label: 'Scene Swap', value: 'background_change', is_default: false },
  { label: 'Colorize', value: 'colorize', is_default: false },
  { label: 'Text to Image', value: 'text_to_image', is_default: false },
  { label: 'Text to Video', value: 'text_to_video', is_default: false },
  { label: 'Image to Video', value: 'image_to_video', is_default: false },
  { label: 'Voice Cloning', value: 'voice_cloning', is_default: false },
  { label: 'Voice Remix', value: 'voice_remix', is_default: false },
  { label: 'Action Generation', value: 'action_generation', is_default: false },
  { label: 'Photo Avatar Talking', value: 'photo_avatar_talking', is_default: false },
  { label: 'Motion Control', value: 'motion_control', is_default: false },
  { label: 'Song Generation', value: 'song_generation', is_default: false },
  { label: 'Video Dubbing', value: 'video_dubbing', is_default: false }
]

export const resolveCreatedWith = (toolIdOrName) => {
  const mapping = {
    [AI_TOOL_IDS.FACE_SWAP]: 'face_swap',
    [AI_TOOL_IDS.SCENE_SWAP]: 'background_change',
    [AI_TOOL_IDS.COLORIZE]: 'colorize',
    [AI_TOOL_IDS.TEXT_TO_IMAGE]: 'text_to_image',
    [AI_TOOL_IDS.TEXT_TO_VIDEO]: 'text_to_video',
    [AI_TOOL_IDS.IMAGE_TO_VIDEO]: 'image_to_video',
    [AI_TOOL_IDS.VOICE_CLONE]: 'voice_cloning',
    [AI_TOOL_IDS.VOICE_REMIX]: 'voice_remix',
    [AI_TOOL_IDS.ACTION_GENERATION]: 'action_generation',
    [AI_TOOL_IDS.TALKING_AVATAR]: 'photo_avatar_talking',
    [AI_TOOL_IDS.MOTION_CONTROL]: 'motion_control',
    [AI_TOOL_IDS.SONG_GENERATION]: 'song_generation',
    [AI_TOOL_IDS.VIDEO_DUBBING]: 'video_dubbing',
    // also handle common string names
    faceswap: 'face_swap',
    'face-swap': 'face_swap',
    'video-face-swap': 'face_swap',
    'video_face_swap': 'face_swap',
    background: 'background_change',
    colorize: 'colorize',
    textToImage: 'text_to_image',
    image_generation: 'text_to_image',
    imagegeneration: 'text_to_image',
    'image-generation': 'text_to_image',
    image_gen: 'text_to_image',
    imagegen: 'text_to_image',
    textToVideo: 'text_to_video',
    video_generation: 'text_to_video',
    videogeneration: 'text_to_video',
    'video-generation': 'text_to_video',
    video_gen: 'text_to_video',
    videogen: 'text_to_video',
    imageToVideo: 'image_to_video',
    textToAudio: 'voice_cloning',
    talkingAvatar: 'photo_avatar_talking',
    motionControl: 'motion_control',
    voiceRemix: 'voice_remix',
    actionGeneration: 'action_generation',
    songGeneration: 'song_generation',
    videoDubbing: 'video_dubbing', 
    // Headings and labels
    'Face Swap': 'face_swap',
    'Scene Swap': 'background_change',
    'Colorize': 'colorize',
    'Text to Image': 'text_to_image',
    'Text to Video': 'text_to_video',
    'Image to Video': 'image_to_video',
    'Voice Cloning': 'voice_cloning',
    'Voice Remix': 'voice_remix',
    'Action Generation': 'action_generation',
    'Talking Avatar': 'photo_avatar_talking',
    'Motion Control': 'motion_control',
    'Video Dubbing': 'video_dubbing',
    'Song Generation': 'song_generation'
  }
  return mapping[toolIdOrName] || toolIdOrName
}

export const resolveToolIdFromPathname = (pathname) => {
  if (!pathname || typeof pathname !== 'string') return null
  const cleanPath = pathname.toLowerCase()
  if (cleanPath.includes('/ai-tool/scene-swap') || cleanPath.includes('/selectbackground')) return AI_TOOL_IDS.SCENE_SWAP
  if (cleanPath.includes('/ai-tool/colorize') || cleanPath.includes('/colorchange')) return AI_TOOL_IDS.COLORIZE
  if (cleanPath.includes('/ai-tool/face-swap')) return AI_TOOL_IDS.FACE_SWAP
  if (cleanPath.includes('/ai-tool/text-to-image')) return AI_TOOL_IDS.TEXT_TO_IMAGE
  if (cleanPath.includes('/ai-tool/text-to-video')) return AI_TOOL_IDS.TEXT_TO_VIDEO
  if (cleanPath.includes('/ai-tool/image-to-video')) return AI_TOOL_IDS.IMAGE_TO_VIDEO
  if (cleanPath.includes('/ai-tool/voice-remix')) return AI_TOOL_IDS.VOICE_REMIX
  if (cleanPath.includes('/ai-tool/voiceclone')) return AI_TOOL_IDS.VOICE_CLONE
  if (cleanPath.includes('/ai-tool/motioncontrol')) return AI_TOOL_IDS.MOTION_CONTROL
  if (cleanPath.includes('/ai-tool/actiongeneration')) return AI_TOOL_IDS.ACTION_GENERATION
  if (cleanPath.includes('/ai-tool/talkingavatar')) return AI_TOOL_IDS.TALKING_AVATAR
  return null
}

export const mapToolNameToId = (toolName) => {
  if (!toolName || typeof toolName !== 'string') return null
  const cleaned = toolName.toLowerCase()
  const normalized = cleaned.replace(/[-_\s]/g, '')
  if (
    cleaned.includes('make me a star') ||
    normalized.includes('makemeastar') ||
    cleaned.includes('face swap') ||
    normalized.includes('faceswap') ||
    cleaned.includes('face_swap') ||
    normalized.includes('videofaceswap') ||
    normalized.includes('video_face_swap') ||
    normalized === 'faceswap' ||
    normalized === 'faceswapping'
  ) return AI_TOOL_IDS.FACE_SWAP
  if (cleaned.includes('bring old photos') || normalized.includes('bringoldphotos') || normalized.includes('oldphotos')) return AI_TOOL_IDS.COLORIZE
  if (cleaned.includes('step into the scene') || normalized.includes('stepintothescene')) return AI_TOOL_IDS.SCENE_SWAP
  if (cleaned.includes('imagine it') || normalized.includes('imagineit') || cleaned.includes('create a scene') || normalized.includes('createascene')) return AI_TOOL_IDS.TEXT_TO_IMAGE
  if (cleaned.includes('animate my scene') || normalized.includes('animatemyscene')) return AI_TOOL_IDS.IMAGE_TO_VIDEO
  if (cleaned.includes('ban jao director') || normalized.includes('banjaodirector')) return AI_TOOL_IDS.TEXT_TO_VIDEO
  if (cleaned.includes('create my voice') || normalized.includes('createmyvoice') || cleaned.includes('clone my voice') || normalized.includes('clonemyvoice')) return AI_TOOL_IDS.VOICE_CLONE
  if (cleaned.includes('sing like a star') || normalized.includes('singlikeastar') || cleaned.includes('sing like a legend') || normalized.includes('singlikealegend')) return AI_TOOL_IDS.VOICE_REMIX
  if (cleaned.includes('animate me') || normalized.includes('animateme')) return AI_TOOL_IDS.ACTION_GENERATION
  if (cleaned.includes('make me a dancer') || normalized.includes('makemeadancer') || cleaned.includes('ban jao dancer') || normalized.includes('banjaodancer')) return AI_TOOL_IDS.MOTION_CONTROL
  if (cleaned.includes('bring my character to life') || normalized.includes('bringmycharactertolife') || cleaned.includes('talk like a character') || normalized.includes('talklikeacharacter')) return AI_TOOL_IDS.TALKING_AVATAR
  if (cleaned.includes('make me a singer') || normalized.includes('makemeasinger') || cleaned.includes('make a song') || normalized.includes('makeasong')) return AI_TOOL_IDS.SONG_GENERATION
  if (cleaned.includes('dub my video') || normalized.includes('dubmyvideo')) return AI_TOOL_IDS.VIDEO_DUBBING
  if (cleaned.includes('action generation') || normalized.includes('actiongeneration') || normalized.includes('actiongen') || normalized === 'action') return AI_TOOL_IDS.ACTION_GENERATION
  if (cleaned.includes('motion control') || normalized.includes('motioncontrol') || normalized === 'motion') return AI_TOOL_IDS.MOTION_CONTROL
  if (cleaned.includes('talking avatar') || normalized.includes('talkingavatar') || normalized.includes('photoavatar') || normalized.includes('avatar')) return AI_TOOL_IDS.TALKING_AVATAR
  if (cleaned.includes('voice remix') || normalized.includes('voiceremix') || normalized.includes('remixvoice')) return AI_TOOL_IDS.VOICE_REMIX
  if (cleaned.includes('voice clone') || normalized.includes('voiceclone') || normalized.includes('voiceclon') || normalized.includes('texttoaudio')) return AI_TOOL_IDS.VOICE_CLONE
  if (
    cleaned.includes('image generation') ||
    normalized.includes('imagegeneration') ||
    normalized.includes('imagegen') ||
    cleaned.includes('img generation') ||
    cleaned.includes('text to image') ||
    normalized.includes('texttoimage') ||
    normalized === 'tti'
  ) return AI_TOOL_IDS.TEXT_TO_IMAGE
  if (
    cleaned.includes('video generation') ||
    normalized.includes('videogeneration') ||
    normalized.includes('videogen') ||
    cleaned.includes('text to video') ||
    normalized.includes('texttovideo') ||
    normalized === 'ttv'
  ) return AI_TOOL_IDS.TEXT_TO_VIDEO
  if (cleaned.includes('image to video') || normalized.includes('imagetovideo') || normalized === 'itv') return AI_TOOL_IDS.IMAGE_TO_VIDEO
  if (cleaned.includes('scene') || cleaned.includes('background') || normalized.includes('bgswap') || normalized.includes('backgroundchange')) return AI_TOOL_IDS.SCENE_SWAP
  if (cleaned.includes('color')) return AI_TOOL_IDS.COLORIZE
  if (
    normalized.includes('songgeneration') ||
    normalized.includes('songgen') ||
    normalized === 'song' ||
    cleaned.includes('song_gen') ||
    cleaned.includes('song gen')
  ) return AI_TOOL_IDS.SONG_GENERATION
  if (
    normalized.includes('videodubbing') ||
    normalized.includes('dubbing') ||
    cleaned.includes('video_dubbing') ||
    cleaned.includes('video dubbing')
  ) return AI_TOOL_IDS.VIDEO_DUBBING
  return null
}

export const getRenamedToolName = (toolIdentifierOrName, fallback = '') => {
  if (!toolIdentifierOrName) return fallback || ''

  if (typeof toolIdentifierOrName === 'object') {
    const resolvedId = resolveToolId(toolIdentifierOrName)
    if (resolvedId && RENAMED_AI_TOOLS[resolvedId]) {
      return RENAMED_AI_TOOLS[resolvedId]
    }
    const rawName =
      toolIdentifierOrName.tool_name ||
      toolIdentifierOrName.display_name ||
      toolIdentifierOrName.title ||
      toolIdentifierOrName.name ||
      toolIdentifierOrName.heading ||
      toolIdentifierOrName.label
    if (rawName && typeof rawName === 'string') {
      const renamed = getRenamedToolName(rawName)
      if (renamed && renamed !== rawName) return renamed
    }
    return rawName || fallback || ''
  }

  if (typeof toolIdentifierOrName === 'string') {
    if (RENAMED_AI_TOOLS[toolIdentifierOrName]) {
      return RENAMED_AI_TOOLS[toolIdentifierOrName]
    }
    const resolvedId = resolveToolId(toolIdentifierOrName)
    if (resolvedId && RENAMED_AI_TOOLS[resolvedId]) {
      return RENAMED_AI_TOOLS[resolvedId]
    }
    return fallback || toolIdentifierOrName
  }

  return fallback || ''
}

export const resolveToolId = (tool) => {
  if (!tool) return null
  if (typeof tool === 'string') {
    for (const [key, id] of Object.entries(AI_TOOL_IDS)) {
      if (tool === id || tool.includes(id)) return id
    }
    if (tool.includes('/')) {
      const fromPath = resolveToolIdFromPathname(tool)
      if (fromPath) return fromPath
    }
    const mapped = mapToolNameToId(tool)
    if (mapped) return mapped
    return tool
  }

  const directId =
    tool?.ai_tool_id ||
    tool?.aiToolId ||
    tool?.tool_id ||
    tool?.toolId ||
    tool?.id ||
    tool?._id ||
    tool?.ai_tool?.ai_tool_id ||
    tool?.ai_tool?.id ||
    tool?.action_property?.ai_tool_id

  if (directId) {
    for (const [key, id] of Object.entries(AI_TOOL_IDS)) {
      if (directId === id || (typeof directId === 'string' && directId.includes(id))) return id
    }
    const mappedDirect = mapToolNameToId(directId)
    if (mappedDirect) return mappedDirect
  }

  const urlCandidate =
    tool?.route ||
    tool?.action_property?.url ||
    tool?.action_property?.route ||
    tool?.action_property?.deeplink ||
    tool?.url

  if (urlCandidate && typeof urlCandidate === 'string') {
    for (const [key, id] of Object.entries(AI_TOOL_IDS)) {
      if (urlCandidate === id || urlCandidate.includes(id)) return id
    }
    const fromUrl = resolveToolIdFromPathname(urlCandidate)
    if (fromUrl) return fromUrl
  }

  const fromName = mapToolNameToId(
    tool?.title || tool?.name || tool?.heading || tool?.label || tool?.action_property?.label
  )
  if (fromName) return fromName

  if (directId && (Object.values(AI_TOOL_IDS).includes(directId) || mapToolNameToId(directId))) {
    return mapToolNameToId(directId) || directId
  }

  return null
}

export const ensureAiToolId = (toolIdentifier) => {
  if (!toolIdentifier) return null
  if (typeof toolIdentifier === 'string' && Object.values(AI_TOOL_IDS).includes(toolIdentifier)) {
    return toolIdentifier
  }
  const resolved = resolveToolId(toolIdentifier)
  if (resolved && Object.values(AI_TOOL_IDS).includes(resolved)) {
    return resolved
  }
  const rawCandidate = typeof toolIdentifier === 'string'
    ? toolIdentifier
    : toolIdentifier?.tool_name || toolIdentifier?.tool_id || toolIdentifier?.ai_tool_id
  const mapped = mapToolNameToId(rawCandidate)
  if (mapped && Object.values(AI_TOOL_IDS).includes(mapped)) {
    return mapped
  }
  const isUuid = (val) => typeof val === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(val)
  if (isUuid(resolved)) return resolved
  if (isUuid(toolIdentifier)) return toolIdentifier
  return null
}

export const isToolIdMatch = (tool, ...toolIds) => {
  if (!toolIds?.length) return false
  const resolvedId = resolveToolId(tool)
  return !!resolvedId && toolIds.includes(resolvedId)
}

export const TOOL_ROUTES = {
  [AI_TOOL_IDS.TEXT_TO_IMAGE]: ROUTES.textToImage || '/ai-tool/text-to-image',
  [AI_TOOL_IDS.TEXT_TO_VIDEO]: ROUTES.textToVideo || '/ai-tool/text-to-video',
  [AI_TOOL_IDS.IMAGE_TO_VIDEO]: ROUTES.imageToVideo || '/ai-tool/image-to-video',
  [AI_TOOL_IDS.FACE_SWAP]: ROUTES.faceSwap || '/ai-tool/face-swap',
  [AI_TOOL_IDS.SCENE_SWAP]: ROUTES.sceneSwap || '/ai-tool/scene-swap',
  [AI_TOOL_IDS.COLORIZE]: ROUTES.colorize || '/ai-tool/colorize',
  [AI_TOOL_IDS.VOICE_REMIX]: ROUTES.voiceRemix || '/ai-tool/voice-remix',
  [AI_TOOL_IDS.VOICE_CLONE]: ROUTES.voiceCloneLanding || '/ai-tool/voiceClone',
  [AI_TOOL_IDS.TALKING_AVATAR]: ROUTES.talkingAvatarLanding || '/ai-tool/talkingAvatar',
  [AI_TOOL_IDS.ACTION_GENERATION]: ROUTES.actionGeneration || '/ai-tool/actionGeneration',
  [AI_TOOL_IDS.MOTION_CONTROL]: ROUTES.motionControl || '/ai-tool/motioncontrol',
  [AI_TOOL_IDS.SONG_GENERATION]: ROUTES.songGeneration || 'https://eu-dev.erosuniverse.com/ai-tool-v2/song-generation',
  [AI_TOOL_IDS.VIDEO_DUBBING]: ROUTES.videoDubbing || 'https://eu-dev.erosuniverse.com/ai-tool-v2/video-dubbing'
}

export const getToolRoute = (tool) => {
  if (!tool) return null

  // 1. Direct route/url defined on tool object
  const directRoute =
    tool?.route ||
    tool?.url ||
    tool?.path ||
    tool?.action_property?.url ||
    tool?.action_property?.route ||
    tool?.action_property?.deeplink
  if (directRoute && typeof directRoute === 'string') {
    return directRoute
  }

  // 2. Resolve via tool ID
  const resolvedId = resolveToolId(tool)
  if (resolvedId && TOOL_ROUTES[resolvedId]) {
    return TOOL_ROUTES[resolvedId]
  }

  // 3. Fallback check by name or code in ROUTES
  const nameOrCode = tool?.tool_name || tool?.name || tool?.code
  if (nameOrCode && typeof nameOrCode === 'string' && ROUTES[nameOrCode]) {
    return ROUTES[nameOrCode]
  }

  return null
}

export const navigateToTool = (tool, navigate, options = {}) => {
  const route = getToolRoute(tool)
  if (!route) return false

  if (route.startsWith('http://') || route.startsWith('https://')) {
    if (options.openNewTab) {
      window.open(route, '_blank')
    } else {
      window.location.href = route
    }
  } else if (navigate && typeof navigate === 'function') {
    const navOpts = options.navigateOptions || (options.state ? { state: options.state } : undefined)
    navigate(route, navOpts)
  }
  return true
}

/** AI Tools Create Page */
export const AI_TOOLS = {
  BG_SWAP: AI_TOOL_IDS.SCENE_SWAP,
  COLORISE: AI_TOOL_IDS.COLORIZE,
  FACE_SWAP: AI_TOOL_IDS.FACE_SWAP
}


export const GOOGLE_CLIENT_ID =
  '321359135622-oamd9d3gprhos6didqtauaa6ugkn762r.apps.googleusercontent.com'

/** Player related constants */
export const PLAYER = {
  THUMBNAIL_VTT_URL:
    'https://www.radiantmediaplayer.com/media/vtt/thumbnails/bbb-thumbnails.vtt'
}

export const TUTORIAL_VIDEO_URLS = {
  MOBILE: {
    '13bc568d-bd0f-4d2a-bd97-fe88c6d47689': [ // FACE_SWAP
      'https://media.erosuniverse.com/immerso/HLS_V/Smart_Search_Templates/vv/IMAGE_FACE_SWAP_MOB_1/master.m3u8',
      'https://media.erosuniverse.com/immerso/HLS_V/Smart_Search_Templates/vv/VIDEO_FACE_SWAP_1/master.m3u8'
    ],

    '7c60ba5d-7a4d-4fc5-a70b-a9fa91a39b30': [ // COLORISE
      'https://media.erosuniverse.com/immerso/HLS_V/Smart_Search_Templates/vv/COLORIZE_MOB_1/master.m3u8'
    ],

    '7c60ba5d-7a4d-4fc5-a70b-a9fa91a39b30_colorize': [ // COLORIZE
      'https://media.erosuniverse.com/immerso/HLS_V/Smart_Search_Templates/vv/COLORIZE_MOB_1/master.m3u8'
    ],

    '93ee5d74-b3c6-4cdf-96ab-e1decb7a39f7': [ // SCENE_SWAP
      'https://media.erosuniverse.com/immerso/HLS_V/Smart_Search_Templates/vv/SCENE_SWAP_MOB_1/master.m3u8'
    ],

    'cba6ff0c-30e5-4568-b266-2c035eceb23b': [ // VOICE_REMIX
      'https://media.erosuniverse.com/immerso/HLS_V/Smart_Search_Templates/vv/VOICE_REMIX_MOB_1/master.m3u8'
    ],

    '53e8d822-56c5-468a-adce-f1c8b1e6164f': [ // VOICE_CLONE
      'https://media.erosuniverse.com/immerso/HLS_V/Smart_Search_Templates/vv/VOICE_CLONE_MOB_1/master.m3u8'
    ],

    '8d018a2a-667d-48d1-8f6b-566d51139945': [ // TEXT_TO_VIDEO
      'https://media.erosuniverse.com/immerso/HLS_V/Smart_Search_Templates/vv/TEXT_TO_VIDEO_MOB_1/master.m3u8'
    ],

    'b0b14e70-e1c2-47b1-80ef-8f707dcfb045': [ // TEXT_TO_IMAGE
      'https://media.erosuniverse.com/immerso/HLS_V/Smart_Search_Templates/vv/TEXT_TO_IMAGE_MOB_1/master.m3u8'
    ],

    '7e9c704c-abea-4b6f-8d1d-96edfbc5787f': [ // TALKING_AVATAR
      'https://media.erosuniverse.com/immerso/HLS_V/Smart_Search_Templates/vv/PHOTO_TALKING_AVATAR_MOB_1/master.m3u8'
    ],

    '8329afcf-233f-479f-9a16-d58a0b0be627': [ // IMAGE_TO_VIDEO
      'https://media.erosuniverse.com/immerso/HLS_V/Smart_Search_Templates/vv/IMAGE_TO_VIDEO_MOB_1/master.m3u8'
    ],

    '65ed7090-9979-41c0-bf5f-73223398dd53': [ // ACTION_GENERATION
      'https://media.erosuniverse.com/immerso/HLS_V/Smart_Search_Templates/vv/ACTION_GENERATION_MOB/master.m3u8'
    ],
    'Chat GPT': [
      'https://media.erosuniverse.com/immerso/HLS_V/Smart_Search_Templates/vv/GPT_MOB_1/master.m3u8'
    ],
    DEFAULT: [
      'https://media.erosuniverse.com/immerso/HLS_V/Smart_Search_Templates/vv/SCENE_SWAP_MOB_1/master.m3u8'
    ],
    HOME: [
      'https://media.erosuniverse.com/immerso/HLS_V/VFS/videos/vv/Eros_Universe_Home_screen_Mobile/master.m3u8'
    ]
  },
  DESKTOP: {
    '13bc568d-bd0f-4d2a-bd97-fe88c6d47689': [ // FACE_SWAP
      'https://media.erosuniverse.com/immerso/HLS_H/VFS/vh/FACE_SWAP_TUTORIAL_EXP_21_01_2026/master.m3u8'
    ],

    '7c60ba5d-7a4d-4fc5-a70b-a9fa91a39b30': [ // COLORISE
      'https://media.erosuniverse.com/immerso/HLS_H/VFS/vh/COLORIZE_TUTORIAL_EXP_21_01_2026/master.m3u8'
    ],

    '7c60ba5d-7a4d-4fc5-a70b-a9fa91a39b30_colorize': [ // COLORIZE
      'https://media.erosuniverse.com/immerso/HLS_H/VFS/vh/COLORIZE_TUTORIAL_EXP_21_01_2026/master.m3u8'
    ],

    '93ee5d74-b3c6-4cdf-96ab-e1decb7a39f7': [ // SCENE_SWAP
      'https://media.erosuniverse.com/immerso/HLS_H/VFS/vh/SCENE_SWAP_TUTORIAL_EXP_21_01_2026/master.m3u8'
    ],

    'cba6ff0c-30e5-4568-b266-2c035eceb23b': [ // VOICE_REMIX
      'https://media.erosuniverse.com/immerso/HLS_H/VFS/vh/VOICE_REMIX_TUTORIAL_EXP_21_01_2026/master.m3u8'
    ],

    '53e8d822-56c5-468a-adce-f1c8b1e6164f': [ // VOICE_CLONE
      'https://media.erosuniverse.com/immerso/HLS_H/VFS/vh/VOICE_CLONE_TUTORIAL_EXP_21_01_2026/master.m3u8'
    ],

    '8d018a2a-667d-48d1-8f6b-566d51139945': [ // TEXT_TO_VIDEO
      'https://media.erosuniverse.com/immerso/HLS_H/VFS/vh/TEXT_TO_VIDEO_TUTORIAL_EXP_22_01_2026/master.m3u8'
    ],

    'b0b14e70-e1c2-47b1-80ef-8f707dcfb045': [ // TEXT_TO_IMAGE
      'https://media.erosuniverse.com/immerso/HLS_H/VFS/vh/TEXT_TO_IMAGE_TUTORIAL_EXP_21_01_2026/master.m3u8'
    ],

    '7e9c704c-abea-4b6f-8d1d-96edfbc5787f': [ // TALKING_AVATAR
      'https://media.erosuniverse.com/immerso/HLS_H/VFS/vh/PHOTO_TALKING_AVATAR_TUTORIAL_EXP_21_01_2026/master.m3u8'
    ],

    '8329afcf-233f-479f-9a16-d58a0b0be627': [ // IMAGE_TO_VIDEO
      'https://media.erosuniverse.com/immerso/HLS_H/VFS/vh/IMAGE_TO_VIDEO_TUTORIAL_EXP_21_01_2026/master.m3u8'
    ],

    '65ed7090-9979-41c0-bf5f-73223398dd53': [ // ACTION_GENERATION
      'https://media.erosuniverse.com/immerso/HLS_H/VFS/vh/ACTION_GENERATION_TUTORIAL_EXP_21_01_2026/master.m3u8'
    ],
    'Chat GPT': [
      'https://mediad.erosuniverse.com/prodimmersobuk01/sa-test/hiw_transcode/gpt-section/desktop/playlist.m3u8'
    ],
    DEFAULT: [
      'https://media.erosuniverse.com/immerso/HLS_V/BACKGROUND_CHANGE_TUTORIAL/master.m3u8'
    ],
    HOME: [
      'https://media.erosuniverse.com/immerso/HLS_H/VFS/videos/vh/Eros_Universe_Home_screen_Web/master.m3u8'
    ]
  }
}

export const BANNER_IMAGES = {
  TEXT_TO_IMAGE:
    'https://mediad.erosuniverse.com/prodimmersobuk02/tools/images/image_text-to-image.png',
  TEXT_TO_VIDEO:
    'https://mediad.erosuniverse.com/prodimmersobuk02/tools/images/image_text-to-video.png',
  VOICE_CLONE:
    'https://mediad.erosuniverse.com/prodimmersobuk02/tools/images/image_voice-clone.png',
  VOICE_REMIX:
    'https://mediad.erosuniverse.com/prodimmersobuk02/tools/images/image_voice-remix.png',
  IMAGE_TO_VIDEO:
    'https://mediad.erosuniverse.com/prodimmersobuk02/tools/images/image_image-to-video.png',
  ACTION_GENERATION:
    'https://mediad.erosuniverse.com/prodimmersobuk02/tools/images/image_action-generation.png',
  TALKING_AVATAR:
    'https://mediad.erosuniverse.com/prodimmersobuk02/tools/images/image_talking-avatar.png',
  MOTION_CONTROL:
    MotionControlBanner
}

export const getDynamicVideoUrls = (howItWorks, aiToolId, isMobileDevice) => {
  if (!howItWorks || !Array.isArray(howItWorks) || howItWorks.length === 0) {
    return null
  }

  const cleanToolId = aiToolId?.split('_')?.[0]
  const getUrl = (item) => (isMobileDevice ? item.mobile_url : item.web_url)

  let matchedItems = []

  if (cleanToolId) {
    // 1. Try to match by tool_id
    matchedItems = howItWorks.filter(
      (item) => item.tool_id && item.tool_id === cleanToolId
    )
  }

  // 2. Try to match by special names if no match by id
  if (matchedItems.length === 0) {
    if (aiToolId === 'Chat GPT') {
      const item = howItWorks.find((i) => i.tool_name === 'Eros GPT')
      if (item) matchedItems = [item]
    } else if (aiToolId === 'HOME') {
      const item = howItWorks.find((i) => i.tool_name === 'Create Home')
      if (item) matchedItems = [item]
    } else if (
      cleanToolId === AI_TOOL_IDS?.COLORIZE ||
      aiToolId === 'colorize' ||
      aiToolId === 'COLORIZE' ||
      cleanToolId === '7c60ba5d-7a4d-4fc5-a70b-a9fa91a39b30'
    ) {
      const item = howItWorks.find(
        (i) => i.tool_name === 'Colorise' || i.tool_name === 'Colorize'
      )
      if (item) matchedItems = [item]
    }
  }

  if (matchedItems.length > 0) {
    const urls = matchedItems.map(getUrl).filter(Boolean)
    if (urls.length > 0) return urls
  }

  return null
}

export const AI_TOOL_ROUTES = {
  '13bc568d-bd0f-4d2a-bd97-fe88c6d47689':  ROUTES.faceSwap || '/ai-tool/face-swap',
  '7c60ba5d-7a4d-4fc5-a70b-a9fa91a39b30':  ROUTES.colorize || '/ai-tool/colorize',
  '93ee5d74-b3c6-4cdf-96ab-e1decb7a39f7': ROUTES.sceneSwap || '/ai-tool/scene-swap',
  'b0b14e70-e1c2-47b1-80ef-8f707dcfb045': ROUTES.textToImage || '/ai-tool/text-to-image',
  '8d018a2a-667d-48d1-8f6b-566d51139945': ROUTES.textToVideo || '/ai-tool/text-to-video',
  '53e8d822-56c5-468a-adce-f1c8b1e6164f': ROUTES.voiceCloneLanding || '/ai-tool/voiceCloneLanding',
  'cba6ff0c-30e5-4568-b266-2c035eceb23b':  ROUTES.voiceRemix || '/ai-tool/voice-remix',
  '8329afcf-233f-479f-9a16-d58a0b0be627': ROUTES.imageToVideo || '/ai-tool/image-to-video',
  '65ed7090-9979-41c0-bf5f-73223398dd53': ROUTES.actionGeneration || '/ai-tool/actionGeneration',
  '7e9c704c-abea-4b6f-8d1d-96edfbc5787f': ROUTES.talkingAvatarLanding || '/ai-tool/talkingAvatarLanding',
  '7e9c704c-abea-4b6f-8d1d-96edfbc578a3': ROUTES.motionControl || '/ai-tool/motioncontrol',
  '2b563806-6ad2-4794-a4fe-fb95bbb17ad2': ROUTES.songGeneration || 'https://eu-dev.erosuniverse.com/ai-tool-v2/song-generation',
  'd1b2c3e4-f5a6-7b8c-9d0e-1f2a3b4c5d6e': ROUTES.videoDubbing || 'https://eu-dev.erosuniverse.com/ai-tool-v2/video-dubbing',
};
export const HOME_PAGE_IDS={
  HIGH_LIGHT:'8d73aa06-ae5e-4570-b62d-c2b1b42e2362',
  TOP_CREATOR:'9c180ac2-97ca-44af-bae0-4e905bcf1036',
  EXPLORE:'216377a7-7237-498e-87ec-17df218e9e16',
  SAVE_DRAFT:'f9d8a1d2-7f17-4474-b48a-c7eb5d6405b8'
}
  // SAVE_DRAFT:'f9d8a1d2-7f17-4474-b48a-c7eb5d6405b8',
  {/* draft is required theen add this key to the HOME_PAGE_IDS object*/}
 export const HIDE_HEADER_ROUTES = [
    ROUTES.login,
    ROUTES.register,
    ROUTES.waitListLanding,
    ROUTES.waitListWelcome,
    ROUTES.waitListLogIn,
    ROUTES.waitListOTP,
    ROUTES.waitListSuccess,
    ROUTES.waitListInvite,
    ROUTES.login,
    ROUTES.register,
    ROUTES.payment,
    ROUTES.splash,
    ROUTES.newPassword,
    ROUTES.forgotPwd,
    ROUTES.otpVarification,
    ROUTES.updatedPayment,
    ROUTES.verifySignup,
    ROUTES.pswUpdated,
    ROUTES.cardDetail,
    ROUTES.faq,
    ROUTES.privacy,
    ROUTES.terms,
    ROUTES.creativeEditor,
    ROUTES.selectTemplate,
    '/content/:id',
    '/reels/:contentId',
    ROUTES.createReels,
    ROUTES.paymentFailed,
    ROUTES.paymentActivation
];

export const MOBILE_HIDDEN_ROUTES = [
  '/ai-tool',
  '/content',
  '/explore-gallery',
  '/motion-control',
  '/gallery',
  '/viewCard',
  ROUTES.source,
  ROUTES.studio,
  ROUTES.rewardSelect,
  ROUTES.setting,
  ROUTES.outPut,
  ROUTES.erosAi,
  ROUTES.dashboardFilter,
  ROUTES.subscriptionSettingPlan,
  ROUTES.wallet,
  ROUTES.subscription,
  ROUTES.earnCoin,
  ROUTES.rewards,
  ROUTES.transactions,
  ROUTES.filterTransaction,
  ROUTES.creatorAppImageList,
  ROUTES.creatorList,
  ROUTES.superAppImageList,
  ROUTES.notifications,
  ROUTES.sSearch,
  ROUTES.search,
  ROUTES.selectBackground,
  ROUTES.avatar,
  ROUTES.editProfile,
  ROUTES.cancleSubscription,
  ROUTES.profile,
  ROUTES.dashboard,
  ROUTES.popularMovies,
  ROUTES.suggestedforyou,
  ROUTES.popularCharacters,
  ROUTES.accountCreationSuccess
]

export const HIDE_SIDEBAR_ROUTES = [
  '/content/:id',
  ROUTES.faceSwap,
  ROUTES.sceneSwap,
  ROUTES.colorize,
  ROUTES.textToImage,
  ROUTES.textToVideo,
  ROUTES.imageToVideo,
  ROUTES.voiceRemix,
  ROUTES.actionGeneration,
  ROUTES.motionControl,
  ROUTES.moderation
]


export const INVITE_ONLY_ROUTES = [
  ROUTES.waitListLanding,
  ROUTES.waitListLogIn,
  ROUTES.waitListOTP,
  ROUTES.waitListSuccess,
  ROUTES.waitListInvite,
  ROUTES.terms,
  ROUTES.privacy
]

export const AI_CONFIG_KEYS = ['ai_download_enabled', 'ai_share_enabled'];

export const HIDE_TRACK_API_ROUTES = [
    ROUTES.waitListLanding,
    '/ai-tool',
    ROUTES.waitListWelcome,
    ROUTES.login,
    ROUTES.splash
]